const initialState = {
	list: [],
	page: 1,
	isListNext: false,
	datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'MAIL_DRAFT_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.list = action.payload.list;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'MAIL_DRAFT_ITEM_SET') {
		let newState = Object.assign({}, state);

		let index = newState.list.findIndex((v) => v.mail_draft_reception_id_code === action.payload.pic);
		if (index >= 0) {
			if (action.payload.type === 'edit') {
				newState.list[index].mail_draft_text = action.payload.mailText;
			}
			else if (action.payload.type === 'del') {
				newState.list.splice(index, 1);
			}
		}
		return newState;

	}
	else if (action.type === 'MAILBOX_DRAFT_SAVING_SET') {
		let newState = Object.assign({}, state);
		newState.saving = action.payload;
		return newState;
	}
	else {
		return state;
	}
}
